import React from 'react';

import { MenuItem } from '@mui/material';

import { Select } from '../Common/Forms/fields';

interface Props {
  isLoading: boolean;
  control: any;
}
export default function SuggestionTypeFiltersDropdown(props: Props) {
  const { isLoading, control } = props;
  return (
    <Select disabled={isLoading} control={control} muiLabel="Surcharge Suggestion Type" name="suggestionType">
      <MenuItem key="increase" value="increase">
        INCREASE
      </MenuItem>
      <MenuItem key="remove" value="remove">
        REMOVE
      </MenuItem>
    </Select>
  );
}
